import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../Styles/Styles/dashboardstyle.css";
import rightImage from "../../Assets/img/test.png";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BASE_URL, security_key } from "../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OtpInput from "react-otp-input";
import LinearProgress from "@mui/material/LinearProgress";

const Forget_verify = () => {
    const navigate = useNavigate();
    const formRef = useRef(null);
    const location = useLocation();
    const email = location.state?.email;

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [count, setCount] = useState(60);
    const timerRef = useRef(null);
    const [otpExpired, setOtpExpired] = useState(false);

    const validationSchema = Yup.object().shape({
        user_otp: Yup.string().length(6, "OTP must be exactly 6 characters").required("OTP is required").strict(),
    });

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerRef.current);
    }, []);

    const startTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        setCount(60);
        setOtpExpired(false);
        let toastShown = false;

        timerRef.current = setInterval(() => {
            setCount((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(timerRef.current);

                    if (!toastShown) {
                        setOtpExpired(true);
                        toast.error("OTP expired. Please request a new one.", { autoClose: 3000 });
                        toastShown = true;
                    }
                    return 0;
                }
                return prevCount - 1;
            });
        }, 1000);
    };

    const resendOtp = async () => {
        setIsSubmitting(true);
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "checkEmail",
                user_email: email,
            });
            const output = response.data;
            if (output === 1) {
                toast.success("OTP sent to Mail", { autoClose: 3000 });
                startTimer();
                formik.setFieldValue("user_otp", "");
            }
        } catch (error) {
            console.error("Error occurred:", error);
            toast.error("An error occurred. Please try again.", { autoClose: 3000 });
        } finally {
            setIsSubmitting(false);
        }
    };

    const initialValues = {
        user_otp: "",
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (formValues) => {
            setIsSubmitting(true);
            try {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "checkOTP",
                    user_email: email,
                    ...formValues,
                });
                const output = response.data;
                if (output === 1) {
                    toast.success("OTP verified successfully!", { autoClose: 3000 });
                    setTimeout(() => navigate("/restpassword", { state: { email } }), 3000);
                } else {
                    toast.error("You've entered an incorrect code!", { autoClose: 3000 });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    return (
        <>
            <ToastContainer position="top-center" />
            <section className="bg-1 site-main">
                <div className="container vh-100 d-flex justify-content-center align-items-center">
                    <div className="site-sub-main bg-white">
                        <div className="field d-none d-lg-block bg-1 text-center">
                            <div className="wrapper">
                                <div className="sub-wrapp d-flex align-items-center justify-content-center mt-5">
                                    <div className="text-box-right text-start p-4">
                                        <h2 className="fw-bold fs-3">Verification</h2>
                                        <p className="mb-1">A OTP was sent to your preferred method</p>
                                    </div>
                                </div>
                                <div className="sub-wrapp">
                                    <img src={rightImage} className="img-fluid" width={"529.09px"} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="field" style={{ height: "520px" }}>
                            <div className="d-flex flex-column justify-content-center align-items-center h-100">
                                <div className="text-header text-center d-flex flex-column align-items-center">
                                    <h2 className="fw-semibold fs-4 mb-1">Verify</h2>
                                    <p className="text-center" style={{ width: "70%", fontSize: "16px", fontWeight: "500" }}>
                                        Enter the OTP that was sent to your e-mail
                                    </p>
                                </div>
                                <form className="d-flex flex-column justify-content-center" onSubmit={formik.handleSubmit} ref={formRef}>
                                    <div className="input-field">
                                        {/* <input
                                            type="text"
                                            className="form-control"
                                            id="user_otp"
                                            value={formik.values.user_otp}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder="Enter OTP"
                                        /> */}
                                        <OtpInput
                                            value={formik.values.user_otp}
                                            onChange={(otp) => formik.setFieldValue("user_otp", otp)}
                                            numInputs={6}
                                            separator={<span>-</span>} // Use 'separator' instead of 'renderSeparator'
                                            inputStyle={{
                                                width: "2.5rem", // Adjust the width as needed
                                                height: "2.5rem", // Adjust the height as needed
                                                margin: "0 0.5rem", // Space between inputs
                                                fontSize: "1.5rem", // Font size for the input
                                                textAlign: "center", // Center the text
                                                color: "black",
                                                backgroundColor: "white", // Ensure visibility
                                                border: "1px solid #ccc", // Add a border for clarity
                                                borderRadius: "4px", // Rounded corners
                                                padding: "0", // Remove default padding
                                                boxSizing: "border-box", // Ensure padding and border are included in width/height
                                            }}
                                            renderInput={(props) => <input {...props} type="text" disabled={otpExpired} />}
                                        />
                                        {formik.errors.user_otp && formik.touched.user_otp && <div className="text-danger f-12">{formik.errors.user_otp}</div>}
                                    </div>
                                    <div className="text-dark text-start align-items-start" style={{ fontSize: "16px", textDecoration: "none" }}>
                                        Didn’t get the code?{" "}
                                        <span
                                            role="button"
                                            className="fw-bold fs-6 text-dark text-decoration-underline"
                                            onClick={resendOtp}
                                            style={{ pointerEvents: otpExpired ? "auto" : "none", color: otpExpired ? "blue" : "gray" }}
                                        >
                                            Resend it
                                        </span>
                                    </div>
                                    <div className="btn-grp mt-3">
                                        <button type="submit" className="btn btn-dark submit-btn fw-semibold" disabled={isSubmitting}>
                                            Verify
                                        </button>
                                    </div>
                                    {isSubmitting && <LinearProgress />}
                                </form>
                                {count > 0 && <p className="mt-2">Resend OTP in {count} seconds</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Forget_verify;
